import BaseService from './baseService';

export interface StartupMessage {
    messageDe: string;
    messageFr: string;
    validUntil: string | null;
}

class StartupMessageService extends BaseService {
    private RESOURCE_URL: string;

    constructor() {
        super();
        this.RESOURCE_URL = `${this.BASE_URL}startup/notification`;
    }

    public async getStartupMessage(): Promise<StartupMessage | null> {
        return this.GET<StartupMessage>(this.RESOURCE_URL);
    }

    public async updateStartupMessage(message: StartupMessage): Promise<any> {
        return this.PUT<StartupMessage>(this.RESOURCE_URL, message);
    }

    /**
     * Generates a hash from the message content (DE + FR)
     * Uses a simple but effective hash algorithm
     */
    public async generateMessageHash(messageDe: string, messageFr: string): Promise<string> {
        const combined = messageDe + '|' + messageFr;

        // Encode the string as UTF-8
        const encoder = new TextEncoder();
        const data = encoder.encode(combined);

        // Generate SHA-256 hash
        const hashBuffer = await crypto.subtle.digest('SHA-256', data);

        // Convert buffer to hex string
        const hashArray = Array.from(new Uint8Array(hashBuffer));
        const hashHex = hashArray.map((b) => b.toString(16).padStart(2, '0')).join('');

        return hashHex;
    }
}

export const startupMessageService = new StartupMessageService();
